/* mgt-unified-product-carousels-v1 */
(function(){
  'use strict';

  function makeButton(direction){
    var button=document.createElement('button');
    button.type='button';
    button.className='mgt-product-carousel-arrow mgt-product-carousel-arrow--'+direction;
    button.setAttribute('data-mgt-carousel-'+direction,'');
    button.setAttribute('aria-label',direction==='prev'?'Vorheriges':'Nächstes');
    button.textContent=direction==='prev'?'‹':'›';
    return button;
  }

  function control(shell,viewport){
    if(!shell||!viewport)return;
    if(shell.dataset.mgtCarouselReady==='1'){
      if(typeof shell.mgtCarouselUpdate==='function')shell.mgtCarouselUpdate();
      return;
    }
    var track=viewport.querySelector(':scope > .product-loop')||viewport.querySelector('.product-loop');
    if(!track||!track.querySelector('.product'))return;
    shell.dataset.mgtCarouselReady='1';
    shell.classList.add('mgt-product-carousel-shell');
    viewport.classList.add('mgt-product-carousel-viewport');
    track.classList.add('mgt-product-carousel-track');
    var prev=makeButton('prev'),next=makeButton('next');
    shell.insertBefore(prev,viewport);
    shell.appendChild(next);

    function update(){
      var max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
      prev.disabled=viewport.scrollLeft<=2;
      next.disabled=viewport.scrollLeft>=max-2;
    }
    function move(direction){
      var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
      var target=Math.max(0,Math.min(max,viewport.scrollLeft+direction*Math.max(180,viewport.clientWidth*.92)));
      var before=viewport.scrollLeft;
      viewport.scrollTo({left:target,behavior:reduced?'auto':'smooth'});
      window.setTimeout(function(){if(Math.abs(viewport.scrollLeft-before)<2&&Math.abs(target-before)>2)viewport.scrollLeft=target;update()},450);
    }
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    viewport.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    shell.mgtCarouselUpdate=update;
    requestAnimationFrame(update);
  }

  function heading(host){
    var title=host&&host.querySelector('h2');
    if(!title)return;
    title.classList.add('mgt-product-carousel-heading');
    if(title.parentElement)title.parentElement.classList.add('mgt-product-carousel-heading-wrap');
  }

  function standard(viewport){
    if(!viewport||viewport.closest('.mz-same-bike'))return;
    var shell=viewport.closest('.glider-contain')||viewport.parentElement;
    var host=viewport.closest('[data-section-type="carousel"],.product-recommendations');
    if(host){host.classList.add('mgt-product-carousel-host');heading(host)}
    control(shell,viewport);
  }

  function curated(group){
    if(!group||group.dataset.mgtCarouselWrapped==='1')return;
    var track=group.querySelector(':scope > .product-loop');
    if(!track||!track.querySelector('.product'))return;
    group.dataset.mgtCarouselWrapped='1';
    group.classList.add('mgt-product-carousel-host');
    heading(group);
    var shell=document.createElement('div');
    var viewport=document.createElement('div');
    viewport.className='mgt-product-carousel-viewport';
    track.parentNode.insertBefore(shell,track);
    shell.appendChild(viewport);
    viewport.appendChild(track);
    control(shell,viewport);
  }

  function scan(root){
    var scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('[data-section-type="carousel"] .glider,.product-recommendations .glider').forEach(standard);
    scope.querySelectorAll('.mz-hb-related-group').forEach(curated);
  }

  function start(){
    scan(document);
    var observer=new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){if(node.nodeType===1){scan(node);scan(node.parentElement)}});
      });
    });
    observer.observe(document.body,{childList:true,subtree:true});
    window.setTimeout(function(){scan(document)},1000);
    window.setTimeout(function(){scan(document)},3500);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
})();
